import { Button } from "@sellar-io/components";
import { SpinnerLegacy } from "../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { useSellarUser } from "../../hooks";
import { useUserUpdate } from "../../hooks/api/v2/user/useUserUpdate";

export const ProfileImageRemoveModal = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const { user } = useSellarUser();

  const userUpdateMutation = useUserUpdate(
    user?.id ? parseInt(user.id.toString()) : 0,
  );

  const upload = () => {
    userUpdateMutation.mutate(
      {
        data: {
          profileImageUrl: null,
        },
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Are you sure you want to remove your profile picture?"}
      />
      <DialogContent>
        {userUpdateMutation.isPending && <SpinnerLegacy />}
      </DialogContent>
      <DialogCTA>
        <Button color={"red"} onClick={upload}>
          Remove
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
